import { useFormContext } from 'react-hook-form';
import { styled } from '@mui/material';

import { Typography, Form, TextField } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { ReportConfigDto } from '../../../../../../dto/ReportConfigDto';

const StyledLabel = styled(Form.Label)({
  flex: '0 0 50%',
});

export type ConfigFormProps = {
  readOnly?: boolean;
  showMinHumanParticipants?: boolean;
};

export const ConfigForm = ({
  readOnly = false,
  showMinHumanParticipants = true,
}: ConfigFormProps) => {
  const { t } = useI18n();
  const {
    control,
    formState: { errors: formErrors },
  } = useFormContext<ReportConfigDto>();

  return (
    <>
      <Form.FieldContainer
        direction="horizontal"
        errorMessage={formErrors.successRate?.message}
      >
        <StyledLabel variant="side">
          {t('prototypes:report.settings.config.success_rate_threshold')}
        </StyledLabel>
        <TextField
          size="small"
          type="number"
          control={control}
          disabled={readOnly}
          error={!!formErrors.successRate}
          inputProps={{ valueAsNumber: true }}
          name="successRate"
          placeholder={t(
            'prototypes:report.settings.config.success_rate_threshold_placeholder'
          )}
        />
        <Typography>%</Typography>
      </Form.FieldContainer>
      <Form.FieldContainer
        direction="horizontal"
        errorMessage={formErrors.dropOffRate?.message}
      >
        <StyledLabel>
          {t('prototypes:report.settings.config.drop_off_rate_threshold')}
        </StyledLabel>
        <TextField
          size="small"
          type="number"
          control={control}
          disabled={readOnly}
          error={!!formErrors.dropOffRate}
          name="dropOffRate"
          placeholder={t(
            'prototypes:report.settings.config.drop_off_rate_threshold_placeholder'
          )}
        />
        <Typography>%</Typography>
      </Form.FieldContainer>
      <Form.FieldContainer
        direction="horizontal"
        errorMessage={formErrors.missclickRate?.message}
      >
        <StyledLabel>
          {t('prototypes:report.settings.config.missclick_rate_threshold')}
        </StyledLabel>
        <TextField
          size="small"
          type="number"
          control={control}
          disabled={readOnly}
          error={!!formErrors.missclickRate}
          name="missclickRate"
          placeholder={t(
            'prototypes:report.settings.config.missclick_rate_threshold_placeholder'
          )}
        />
        <Typography>%</Typography>
      </Form.FieldContainer>
      <Form.FieldContainer
        direction="horizontal"
        errorMessage={formErrors.timeToSuccess?.message}
      >
        <StyledLabel>
          {t('prototypes:report.settings.config.time_to_success_threshold')}
        </StyledLabel>
        <TextField
          size="small"
          type="number"
          control={control}
          disabled={readOnly}
          error={!!formErrors.timeToSuccess}
          name="timeToSuccess"
          placeholder={t(
            'prototypes:report.settings.config.time_to_success_threshold_placeholder'
          )}
        />
        <Typography>s</Typography>
      </Form.FieldContainer>
      {showMinHumanParticipants ? (
        <Form.FieldContainer
          direction="horizontal"
          errorMessage={formErrors.minimumHumanParticipants?.message}
        >
          <StyledLabel>
            {t('prototypes:report.settings.config.min_human_participants')}
          </StyledLabel>
          <TextField
            size="small"
            type="number"
            control={control}
            disabled={readOnly}
            error={!!formErrors.minimumHumanParticipants}
            name="minimumHumanParticipants"
            placeholder={t(
              'prototypes:report.settings.config.min_human_participants_placeholder'
            )}
          />
        </Form.FieldContainer>
      ) : null}
      <Form.FieldContainer
        direction="horizontal"
        errorMessage={formErrors.minimumAiParticipants?.message}
      >
        <StyledLabel>
          {t('prototypes:report.settings.config.min_ai_participants')}
        </StyledLabel>
        <TextField
          size="small"
          type="number"
          control={control}
          disabled={readOnly}
          error={!!formErrors.minimumAiParticipants}
          name="minimumAiParticipants"
          placeholder={t(
            'prototypes:report.settings.config.min_ai_participants_placeholder'
          )}
        />
      </Form.FieldContainer>
    </>
  );
};
